import { Injectable, inject } from '@angular/core';

import { EAnalyticsGoal } from './analytics.goals';
import { GtmService, IConsentKey, IConsentState } from './gtm.service';
import { ITracker, TRACKERS } from './tracker';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    readonly #trackers: readonly ITracker[] = inject(TRACKERS);
    readonly #gtm: GtmService = inject(GtmService);

    public bootstrap(): void {
        for (const tracker of this.#trackers) {
            tracker.bootstrap();
        }
    }

    public trackPageView(url: string, title?: string): void {
        for (const tracker of this.#trackers) {
            tracker.pageView(url, title);
        }
    }

    public trackGoal(goal: EAnalyticsGoal, params?: Record<string, unknown>): void {
        for (const tracker of this.#trackers) {
            tracker.event(goal, params);
        }
    }

    public setUserId(id: string, props?: Record<string, unknown>): void {
        for (const tracker of this.#trackers) {
            tracker.setUser(id, props);
        }
    }

    public updateConsent(update: Partial<Record<IConsentKey, IConsentState>>): void {
        this.#gtm.consent(update);
    }
}
